import { cn } from "@win-reality/react-ui";

/**
 * Border and text color shared by the outlined (`secondary-flat-dark-outline`)
 * action buttons: Time Remaining, Manage Lineups, and the player cards'
 * actions. The variant's colors come from react-ui's own stylesheet, which
 * sits outside Tailwind's layers and beats plain utilities, so these are
 * important.
 */
export const OUTLINE_BUTTON_COLOR_CLASS = cn(
  // Border
  "border-tagging-outline-button!",
  // Text
  "text-tagging-outline-button!",
);

/** The sidebar's outlined buttons. */
export const SIDEBAR_BUTTON_CLASS = cn(
  // Size: taller than size="sm"'s h-8.5
  "h-10 w-full",
  // Border
  "rounded-full",
  OUTLINE_BUTTON_COLOR_CLASS,
);
